import { Platform, StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: { flexGrow: 1, flexBasis: 0 },
  scrollContainer: { marginHorizontal: 16 },
  descriptionContainer: { marginTop: 33 },
  cardView: theme => ({
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 4.65,
    elevation: 8,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    paddingHorizontal: 16,
    marginBottom: 16,
  }),
  essentialPadding: { paddingTop: 16, paddingBottom: 25 },
  essentialRow: { flexDirection: 'row', alignItems: 'center' },
  essentialTitle: theme => ({
    flex: 1,
    color: theme.colors.text.primary,
    fontSize: 18.7,
    lineHeight: 25,
    marginStart: 8,
    marginTop: Platform.OS === 'ios' ? 3 : 0,
  }),
  essentialState: theme => ({
    color: theme.colors.text.primary,
    fontSize: 14.6,
    lineHeight: 25,
    marginTop: Platform.OS === 'ios' ? 3 : 0,
  }),
  essentialDescription: theme => ({
    color: theme.colors.text.primary,
    fontSize: 14.6,
    lineHeight: 18.7,
    marginStart: 42,
    marginTop: 5,
  }),
  permissionItem: theme => ({
    marginEnd: undefined,
    color: theme.colors.text.primary,
    marginTop: 16,
    marginBottom: 10,
  }),
});
